/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-06 14:25:57
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 12:34:58
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragRowDisplay/Image/index.tsx
 */
import React from 'react'; //, { useState }

import { useSingleImageEffect } from '@/src/components/Upload';
import DeleteButton from 'src/components/Buttons/DeleteButton';
import { Uploader } from 'src/components/Upload';
//import { ImageDisplaySetting } from '@/src/components/Upload';
import _, { get } from 'lodash'; //, { cloneDeep }
import FocusPoint from 'src/components/ImageFocusPointEdit';
import css from './css.module.less';

const DraggableImageDisplay = (props) => {
  const {
    topPart,
    title,
    subtitle,
    onDelete,
    imgOnChange,
    linkImage,
    error,
    description,
    btnText,
    type,
    className,
    className2,
    //showImageDisplaySetting,
    disabled,
    hideEdit,
  } = props;
  //const [visible, setVisible] = useState(false);
  const [fileList, setFileList] = React.useState(linkImage ? [linkImage] : []);
  useSingleImageEffect(linkImage, fileList, setFileList);
  // const coordinate =
  //   linkImage?.imageSetting?.left &&
  //   linkImage?.imageSetting?.top &&
  //   linkImage?.imageSetting?.bottom &&
  //   linkImage?.imageSetting?.right
  //     ? {
  //         leftTop: linkImage?.imageSetting?.left,
  //         rightTop: linkImage?.imageSetting?.top,
  //         leftBottom: linkImage?.imageSetting?.bottom,
  //         rightBottom: linkImage?.imageSetting?.right,
  //       }
  //     : undefined;
  //const coordinateFocal = linkImage?.imageSetting?.focus;

  const handleChangeImage = (img) => {
    if (imgOnChange) {
      imgOnChange(get(img, 'image'));
    }
    //setVisible(false);
  };

  //const hasData = (linkImage || {}).uuid;

  return (
    <div className={`${css.container} ${className || ''}`}>
      {onDelete && !disabled && (
        <div className={css.deleteIconContainer}>
          {' '}
          <DeleteButton className={css.deleteIcon} onClick={onDelete} />
        </div>
      )}
      {topPart || null}
      <div className={className2}>
        <div className={css.titleRow}>
          <div className={css.titleContainer}>
            <div className={css.title}>{title}</div>

            <div className={css.subtitle}>{subtitle}</div>
          </div>
        </div>
        <div className={css.imgPlaceholder}>
          <Uploader
            type={type}
            description={description}
            btnText={btnText}
            height={180}
            hideEdit={hideEdit ?? disabled} //满足单个edit编辑需求 UXPSA-14101
            hideRemove={disabled}
            hideReplace={disabled}
            disabled={disabled}
            multiple={false}
            fileList={fileList}
            onChange={(imgArr = []) => {
              setFileList(imgArr);
              if (imgOnChange) {
                const _l = _.last(imgArr);
                imgOnChange(_l);
              }
            }}
          />
          <FocusPoint
            className={css.imageSetting}
            image={get(fileList, 0)}
            onChange={handleChangeImage}
            disable={disabled}
          />
          {/* {hasData && showImageDisplaySetting && (
            <>
              <div
                className={css.imageSetting}
                onClick={() => setVisible(!!linkImage?.url)}>
                {'Image Display Setting'}
              </div>
              <ImageDisplaySetting
                src={linkImage?.url}
                value={coordinate}
                visible={visible}
                focalValue={coordinateFocal}
                onCancel={() => setVisible(false)}
                onOk={handleChangeImage}
              />
            </>
          )} */}
          {error && <div className={css.errText}>{error}</div>}
        </div>
      </div>
    </div>
  );
};
export default DraggableImageDisplay;
